<template lang="pug">
  .component-backoffice-edit-zone
    .row
      .columns
        .card
          .inner-content
            LoadingSpinner(v-if="!zone.name")
            template(v-else)
              h2 Editing zone {{ $route.params.id }}
              .row
                .column.small-12.large-6
                  label Name
                  TranslateField(group="entities", :field="zone._translatable.name", label="Name", :value="zone.name")
                    input.input-group-field(type="text", v-model="zone.name")
              .row.column
                label Add from geojson
                  textarea(rows="10", v-model="zone.poly")
                GoogleMapContainer
                  google-map(
                  :zoomControl="true",
                  :mapTypeControl="true",
                  :search-bar="true",
                  ref="map", :api-key="apiKey",
                  :center="mapCenter", v-if="mapCenter.lat !== 0 && mapCenter.lng !== 0", :libraries="['places','visualization','drawing']")
                    google-map-drawing-manager(@updated="shapeUpdated", v-if="zone.poly", :initial="zone.poly")
              .row.column.mt-3
                button.button(@click="updateZone") Update

</template>

<script>
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice"
  import MaggieHelper from "../../maggieHelper"

  import GoogleMap from '../../lib/map/GoogleMap';
  import GoogleMapDrawingManager from '../../lib/map/GoogleMapDrawingManager'
  import LoadingSpinner from "../../components/structure/LoadingSpinner";
  import GoogleMapContainer from '../../components/backoffice/GoogleMapContainer'
  import TranslateField from "./TranslateField.vue";


  export default {
    name: "EditZone",
    components: {TranslateField, GoogleMapContainer, LoadingSpinner, GoogleMap, GoogleMapDrawingManager},
    data() {
      return {
        apiKey: null,
        geoData: null,
        body: {
          name: null,
          poly: null
        },
        mapCenter: {
          lat: 0,
          lng: 0,
        },
        zone: {},
        confirmed: false
      }
    },
    created() {
      this.apiKey = window.env.GOOGLE_MAPS_KEY
    },
    mounted() {
      KeplerBackofficeSdk.configuration.get((data) => {
        this.mapCenter.lat = data.application.application_default_latitude.value
        this.mapCenter.lng = data.application.application_default_longitude.value
      })

      KeplerBackofficeSdk.zones.select(this.$route.params.id).get((data) => {
        this.zone = data
      })
    },
    methods: {
      shapeUpdated(data) {
        this.zone.poly = data
        this.confirmed = true
      },
      updateZone() {
        if(this.confirmed) {
          KeplerBackofficeSdk.zones.select(this.$route.params.id).update(this.zone, () => {
            MaggieHelper.notification('Zone', 'Zone edited successfully')
            this.$router.push({path: 'assets', name: 'zone-management'})
          })
        } else {
          alert("PRESS CONFIRM ON THE MAP BEFORE UPDATING THE ZONE")
        }
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// EditZone.vue?69d74a86